export const FILTER_MAX_LENGTH = 100;
